/* tslint:disable */

/**
 */
export class TicketDestroyAccept {
    id?: number;
    type?: string;
    restore_deposit_month?: number;
}
